<template>
    <div class="mt-5">
        <div class="grid grid-cols-5 gap-4">
            <div>
                <navigation
                    :navigation="[
                        { name: 'Invite Members', route: {name:'auditoria.mozart.invite-members'}, icon: UserPlusIcon },
                    ]"
                />
            </div>
            <div class="col-span-4">
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>

<script>
    import Navigation from "../../components/layouts/navigation/vertical/Navigation.vue";
    import { UserPlusIcon } from "@heroicons/vue/24/outline";

    export default {
        methods: { UserPlusIcon },
        components: { Navigation },

        mounted() {
            if (this.$route.name === 'auditoria.mozart') {
                this.$router.push({ name: 'auditoria.mozart.invite-members' });
            }
        }
    }
</script>
